var map = {
	"./banner-bg.jpg": 624,
	"./buy_x.jpg": 625,
	"./commercial_x.jpg": 626,
	"./cottage_x.jpg": 627,
	"./new_buildings_x.jpg": 628,
	"./rent-day_x.jpg": 629,
	"./rent-long_x.jpg": 630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;